import React from 'react';
import LocationPin from "./LocationPin";
import LocationToolTip from "./LocationToolTip";
import PropTypes from "prop-types";

function MapMarker ({ name, uid, onClick, selected, closeModal }) {

    return (
        <div>
            <LocationPin selected={selected} onClick={onClick} />

            {selected && <LocationToolTip uid={uid} name={name} closeModal={closeModal} />}
        </div>
    );
}

MapMarker.propTypes = {
    name: PropTypes.string,
    uid: PropTypes.number,
    mapLatitude: PropTypes.number,
    mapLongitude: PropTypes.number,
    onClick: PropTypes.func,
    selectedPin: PropTypes.bool,
    closeModal: PropTypes.func
};

export default MapMarker;




// WEBPACK FOOTER //
// ./src/components/Map/MapMarker.js